module.exports = __webpack_public_path__ + "static/media/Xerath_0.dc049599.png";